// Filtros.jsx
import React from 'react';
import { Form, Button } from 'react-bootstrap';
import styled from 'styled-components';

const Filtros = ({ filtros, handleFiltroChange, fetchData, handleLimparFiltros }) => {
  return (
    <FiltrosContainer>
      <StyledForm>
        <div className="filtros-grid">
          <Form.Control
            name="LocalCidade"
            placeholder="Cidade"
            value={filtros.LocalCidade}
            onChange={handleFiltroChange}
            className="filtro-input"
          />
          <Form.Control
            name="LocalEstado"
            placeholder="Estado"
            value={filtros.LocalEstado}
            onChange={handleFiltroChange}
            className="filtro-input"
          />
          <Form.Control
            name="Frota"
            placeholder="Frota"
            value={filtros.Frota}
            onChange={handleFiltroChange}
            className="filtro-input"
          />
          <Form.Control
            name="Veiculo"
            placeholder="Placa do Veículo"
            value={filtros.Veiculo}
            onChange={handleFiltroChange}
            className="filtro-input"
          />
          <Form.Control
            name="NomeGestor"
            placeholder="Nome do Gestor"
            value={filtros.NomeGestor}
            onChange={handleFiltroChange}
            className="filtro-input"
          />
          <Form.Control
            name="NomeComercial"
            placeholder="Nome Comercial"
            value={filtros.NomeComercial}
            onChange={handleFiltroChange}
            className="filtro-input"
          />
          <Form.Control
            name="Destino"
            placeholder="Destino"
            value={filtros.Destino}
            onChange={handleFiltroChange}
            className="filtro-input"
          />
          <Form.Select
            name="Vazio"
            value={filtros.Vazio}
            onChange={handleFiltroChange}
            className="filtro-input"
          >
            <option value="">Vazio?</option>
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </Form.Select>
          <Form.Select
            name="Coleta"
            value={filtros.Coleta}
            onChange={handleFiltroChange}
            className="filtro-input"
          >
            <option value="">Coleta?</option>
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </Form.Select>
          <Form.Select
            name="Negociacao"
            value={filtros.Negociacao}
            onChange={handleFiltroChange}
            className="filtro-input"
          >
            <option value="">Negociação?</option>
            <option value="true">Sim</option>
            <option value="false">Não</option>
          </Form.Select>
        </div>

        <div className="filtros-actions">
          <Button variant="primary" size="sm" onClick={fetchData}>
            Pesquisar
          </Button>
          <Button variant="light" size="sm" onClick={handleLimparFiltros}>
            Limpar
          </Button>
        </div>
      </StyledForm>
    </FiltrosContainer>
  );
};

const FiltrosContainer = styled.div`
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  border: 1px solid #e9ecef;
`;

const StyledForm = styled.form`
  .filtros-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 15px;
    margin-bottom: 20px;
  }

  .filtro-input {
    border: 1px solid #ced4da;
    border-radius: 4px;
    padding: 8px 12px;
    font-size: 14px;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

    &:focus {
      border-color: #80bdff;
      outline: 0;
      box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
  }

  .filtros-actions {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    flex-wrap: wrap;

    @media (max-width: 768px) {
      justify-content: center;
    }
  }

  @media (max-width: 768px) {
    .filtros-grid {
      grid-template-columns: 1fr;
      gap: 10px;
    }
  }
`;


export default Filtros;
